function makeEmptyImageCaption() {
  return {
    authorOrArtist: undefined,
    caption: undefined,
    copyright: undefined,
    country: undefined,
    description: undefined,
    duration: undefined,
    title: undefined,
    year: undefined,
    numberOfPages: undefined
  };
}

export { makeEmptyImageCaption };
//# sourceMappingURL=maker.empty-caption.js.map
